import {
  GiftCardHeader,
  GiftCardInfo,
  GiftCardOrders,
  GiftCardRedemption,
  GiftCardRedemptionForm,
} from './components';

export * from './hooks';

export const GiftCard = {
  Account: {
    Header: GiftCardHeader,
    Info: GiftCardInfo,
    Redemption: GiftCardRedemption,
    Orders: GiftCardOrders,
  },
  RedemptionForm: GiftCardRedemptionForm,
};
